meedy.controller('meedy.myDataController', ['$scope', '$state', '$mdToast', '$mdDialog', 'meedy.objectHelper', 'Upload', 'applicationModel', 'meedy.userModel', 'meedy.resourceModel', 'meedy.dictionaryModel', 'meedy.accountingModel', 'medicalPostModel', '$translate',
    function ($scope, $state, $mdToast, $mdDialog, objectHelper, Upload, applicationModel, userModel, resourceModel, dictionaryModel, accountingModel, medicalPostModel, $translate) {

        function setData() {
            $scope.wrapper = new MyDataWrapperMeedyVO();
            $scope.offices = [];
            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 99;

            $scope.address = undefined;
            $scope.selectedAddress = undefined;
            $scope.addressPointer = 1;

            $scope.phoneRegExp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
            $scope.stateList = [];
            $scope.specializationList = [];
            $scope.academicTitleList = [];
            $scope.medicalChamberList = [];

            $scope.searchTitle = '';

            $scope.forms = {
                myData : null
            };

            $scope.pictureSize = 160;
            $scope.pictureFile = null;
            $scope.userCertificate = null;
            $scope.medicalCertificateTLS = null;
            $scope.medicalCertificateWSS = null;
            $scope.croppedPictureData = '';
            $scope.refreshingDataAfterPictureUpload = false;

            $scope.officeAddresses = [];
            $scope.ageList = [
                {value : 0, label : $scope.T('T.MEEDY.MODULE.MY_DATA.UNDER') + ' 1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR') },
                {value : 1, label : '1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR') }
            ];
            for(var i = 2; i < 19; i++) {
                $scope.ageList.push({value : i, label : i + ' ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEARS') });
            }

            $scope.Enum = Enum;

            $scope.duplicatedNip = false;
            $scope.duplicatedRegon = false;
            $scope.duplicatedPwz = false;

            $scope.pwzRequired = false;

            $scope.newNfzContractNr = null;
            $scope.newNfzBranch = null;

            $scope.hideAddButton();
            $scope.hideBackButton();
            $scope.resetTitle();

        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST ||
                                    userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;

            $scope.isAlabDiagnostician = userModel.currentUser.alabDiagnostician;
            $scope.isViprotect = userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT;
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function(event, dataPage) {
                $scope.stateList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_SPECIALIZATIONS.SUCCESS, function(event, dataPage) {
                    $scope.specializationList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.SUCCESS, function(event, dataPage) {
                for(var i = 0; i < dataPage.data.length; i++) {
                    $scope.academicTitleList.push(dataPage.data[i].name);
                }
            });

            $scope.$on(Event.MEEDY.USER.PWZ_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedPwz = answer.exists;
                $scope.forms.myData["pwz"].$validate();
            });
            $scope.$on(Event.MEEDY.ACCOUNTING.NIP_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedNip = answer.exists;
                $scope.forms.myData['nip'].$validate();
            });
            $scope.$on(Event.MEEDY.ACCOUNTING.REGON_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedRegon = answer.exists;
                $scope.forms.myData['regon'].$validate();
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.officeAddresses = [];
                for(var i = 0; i < dataPage.data.length; i++) {
                    $scope.officeAddresses.push({value : dataPage.data[i], label : dataPage.data[i].name });

                    if($scope.wrapper && dataPage.data[i].id === $scope.wrapper.medicalPost.correspondenceAddressResourceId) {
                        $scope.selectedAddress = dataPage.data[i];
                    }
                }
            });

            $scope.$on(Event.MEEDY.USER.GET_MY_DATA.SUCCESS, function(event, wrapper) {
                if ($scope.refreshingDataAfterPictureUpload) {
                    $scope.wrapper.user.pictureUrl = wrapper.user.pictureUrl;
                    $scope.refreshingDataAfterPictureUpload = false;
                }
                else {
                    $scope.wrapper = wrapper;

                    switch ($scope.wrapper.medicalPost.correspondenceAddressType) {
                        case Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST:
                            $scope.addressPointer = 1;
                            break;
                        case Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.RESOURCE:
                            $scope.addressPointer = 2;
                            for (var i = 0; i < $scope.officeAddresses.length; i++) {
                                if ($scope.wrapper.medicalPost.correspondenceAddressOther && $scope.wrapper.medicalPost.correspondenceAddressOther.id === $scope.officeAddresses[i].value.address.id) {
                                    $scope.selectedAddress = $scope.officeAddresses[i].value;
                                }
                            }
                            break;
                        case Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.OTHER:
                            $scope.addressPointer = 3;
                            $scope.addres = $scope.wrapper.medicalPost.correspondenceAddressOther;
                            break;
                        default :
                            $scope.wrapper.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST;
                            break;
                    }

                    $scope.address = $scope.wrapper.medicalPost.correspondenceAddressOther;
                }
            });

            $scope.$on(Event.MEEDY.USER.UPDATE_MY_DATA.SUCCESS, function(event, data) {
                userModel.currentUser.pwz = $scope.wrapper.physicianDetails.pwz;
                if(userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT) {

                    if(!userModel.currentUser.resources || userModel.currentUser.resources.length === 0) {
                        console.log('here 2');
                        var configPopup = {
                            templateUrl: 'meedy/application/view/app/popup/popup-fill-price-list.html',
                            controller: 'meedy.popupFillDataController',
                            locals: {
                                $scope: $scope,
                                $mdDialog: $mdDialog
                            }
                        };
                        $mdDialog.show(configPopup).then(function() {
                            $state.go(Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST);
                        });
                    } else {
                        console.log('here 3');
                        var officeId = userModel.currentUser.resources[0].id;
                        resourceModel.getPricelist(officeId);
                    }
                }
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_PRICE_LIST.SUCCESS, function(event, priceList) {
                console.log('here 4');
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$watch('wrapper.physicianDetails.allowChildren', function(newValue, oldValue){
                if(newValue === false) {
                    $scope.wrapper.physicianDetails.childrenAgeLowerLimit = undefined;
                    $scope.wrapper.physicianDetails.childrenAgeUpperLimit = undefined;
                }
            });

            $scope.$watch('wrapper.physicianDetails.firstSpecialization', function(newValue, oldValue){
                $scope.evaluatePwzRequirement();
            });

            $scope.$watch('wrapper.physicianDetails.secondSpecialization', function(newValue, oldValue){
                $scope.evaluatePwzRequirement();
            });

            $scope.$watch('addressPointer', function(newValue, oldValue){
                switch(newValue) {
                    case 1:
                        $scope.address = $scope.wrapper.medicalPost.address;
                        $scope.wrapper.medicalPost.correspondenceAddressResourceId = null;
                        $scope.wrapper.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST;
                        break;
                    case 2:
                        if($scope.selectedAddress) {
                            $scope.address = $scope.selectedAddress.address;
                            $scope.wrapper.medicalPost.correspondenceAddressResourceId = $scope.selectedAddress.id;
                        }
                        $scope.wrapper.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.RESOURCE;
                        break;
                    case 3:
                        if($scope.wrapper.medicalPost.correspondenceAddressOther) {
                            $scope.address = $scope.wrapper.medicalPost.correspondenceAddressOther;
                        } else {
                            $scope.address = new AddressMeedyVO();
                        }
                        $scope.wrapper.medicalPost.correspondenceAddressResourceId = null;
                        $scope.wrapper.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.OTHER;
                        break;
                }
            });

            $scope.onSelectedAddressChange = function(newValue, oldValue) {
                if($scope.addressPointer == 2 && newValue) {
                    $scope.address = newValue.address;
                    $scope.selectedAddress = newValue;
                    $scope.wrapper.medicalPost.correspondenceAddressResourceId = newValue.id;
                }
            };
        }

        function setActions() {

            $scope.updateDetails = function() {
                $scope.forms.myData.$setSubmitted();
                if($scope.forms.myData.$valid) {

                    $scope.wrapper.medicalPost.correspondenceAddressOther = $scope.address;
                    if (Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.RESOURCE === $scope.wrapper.medicalPost.correspondenceAddressType) {
                        $scope.wrapper.medicalPost.correspondenceAddressResourceId = $scope.selectedAddress.id;
                    }

                    $scope.wrapper.physicianDetails.title = $scope.searchTitle;
                    userModel.updateMyData($scope.wrapper);
                }
            };

            $scope.uploadPicture = function(pictureData, pictureName) {
                var croppedFile = Upload.dataUrltoBlob(pictureData, pictureName);
                userModel.uploadMyPicture(croppedFile);

                var successWatcherDisabler = $scope.$on(Event.MEEDY.USER.UPLOAD_MY_PICTURE.SUCCESS, function (event, result) {
                    successWatcherDisabler();
                    errorWatcherDisabler();

                    $scope.refreshingDataAfterPictureUpload = true;
                    $scope.pictureFile = null;
                    $scope.croppedPictureData = '';

                    userModel.getMyData();
                });

                var errorWatcherDisabler = $scope.$on(Event.MEEDY.USER.UPLOAD_MY_PICTURE.ERROR, function (event, error) {
                    successWatcherDisabler();
                    errorWatcherDisabler();
                });
            };

            $scope.updateUserCertificate = function(userCertificate) {
                userModel.uploadUserCertificate(userCertificate)
                    .then( function(response) {
                        $scope.wrapper.user.zusCertificate = true;
                        $scope.userCertificate = null;
                        $scope.forms.myData.userCertificate.$setViewValue(null);
                    });
            };

            $scope.deleteUserCertificate = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/popup/popup-confirmation.html',
                    controller: 'popupConfirmationController',
                    resolve: {
                        title: function() {
                            return null;
                        },
                        message: function() {
                            return 'T.MEEDY.MODULE.MY_DATA.DELETE_CERT';
                        },
                        labels: function() {
                            return [];
                        },
                        yesText: function() {
                            return null;
                        },
                        noText: function() {
                            return null;
                        }
                    }
                }).then( function() {
                    userModel.deleteUserCertificate()
                        .then( function(response) {
                            $scope.wrapper.user.zusCertificate = false;
                        });
                });
            };

            $scope.deleteNfzContract = function (id) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('Czy na pewno chcesz usunąć e-skierowanie ?'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });

                $mdDialog.show(confirm).then(function () {
                    userModel.deleteNfzContract(id).then(function() {
                        userModel.getLoggedUser();
                        userModel.getMyData();
                    });
                });
            }

            $scope.addNfzContract = function() {
                if ($scope.newNfzContractNr && $scope.newNfzBranch) {
                    userModel.addNfzContract($scope.newNfzContractNr, $scope.newNfzBranch).then(function() {
                        $scope.newNfzContractNr = null;
                        $scope.newNfzBranch = null;
                        userModel.getLoggedUser();
                        userModel.getMyData();
                    });
                }
            }

            $scope.updateMedicalCertificates = function(medicalCertificateTLS, medicalCertificateWSS) {

                var configPopup = {
                    templateUrl: 'meedy/application/view/app/popup/popup-sign-certificates.html',
                    controller: 'meedy.popupSignCertificatesController',
                    controllerAs: 'signCertificatesCtrl',
                    skipHide: true,
                    locals: {
                        $scope: $scope,
                        $mdDialog: $mdDialog,
                        title: 'T.MEEDY.MODULE.MY_DATA.SIGN_CERTS',
                        message: 'T.MEEDY.MODULE.MY_DATA.GET_PASSWORD'
                    }
                };

                $mdDialog.show(configPopup).then(function(password) {
                    if(password) {
                        userModel.uploadMedicalCertificates(medicalCertificateTLS, medicalCertificateWSS, password)
                            .then( function(response) {
                                $scope.wrapper.medicalPost.p1Certificates = true;
                                $scope.medicalCertificateTLS = null;
                                $scope.medicalCertificateWSS = null;
                                $scope.forms.myData.medicalCertificateTLS.$setViewValue(null);
                                $scope.forms.myData.medicalCertificateWSS.$setViewValue(null);
                            })
                            .catch( function(errorResponse) {
                                $mdDialog.show({
                                    templateUrl: 'meedy/application/view/app/popup/popup-alert.html',
                                    controller: 'meedy.popupAlertController',
                                    resolve: {
                                        message: function () {
                                            return 'T.MEEDY.MODULE.MY_DATA.ALERT_STH_GOES_WRONG';
                                        },
                                        title: function () {
                                            return 'T.DATA.ALERT';
                                        }
                                    }
                                });
                            });
                    }
                });
            };

            $scope.deleteMedicalCertificates = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/popup/popup-confirmation.html',
                    controller: 'popupConfirmationController',
                    resolve: {
                        title: function() {
                            return null;
                        },
                        message: function() {
                            return 'T.MEEDY.MODULE.MY_DATA.DELETE_CERTS';
                        },
                        labels: function() {
                            return [];
                        },
                        yesText: function() {
                            return null;
                        },
                        noText: function() {
                            return null;
                        }
                    }
                }).then( function() {
                    userModel.deleteMedicalCertificates()
                        .then( function(response) {
                            $scope.wrapper.medicalPost.p1Certificates = false;
                        });
                });
            };

            $scope.deletePicture = function() {
                userModel.deleteMyPicture();

                var successWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.SUCCESS, function (event, result) {
                    successWatcherDisabler();
                    errorWatcherDisabler();

                    $scope.refreshingDataAfterPictureUpload = true;
                    userModel.getMyData();
                });

                var errorWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.ERROR, function (event, error) {
                    successWatcherDisabler();
                    errorWatcherDisabler();
                });
            };

            $scope.newAcademicTitle = function(searchText) {
                $scope.academicTitleList.push(searchText);
            };

            $scope.getMatches = function(query) {
                var results = [];

                for(var i = 0; i < $scope.academicTitleList.length; i++) {
                    if($scope.academicTitleList[i].indexOf(query) > -1) {
                        results.push($scope.academicTitleList[i]);
                    }
                }

                return results;
            };

            $scope.validateNip = function() {
                if($scope.wrapper.medicalPostAccounting.nip) {
                    accountingModel.nipExistence($scope.wrapper.medicalPostAccounting.nip);
                }
            };

            $scope.validateRegon = function() {
                if($scope.wrapper.medicalPostAccounting.regon) {
                    accountingModel.regonExistence($scope.wrapper.medicalPostAccounting.regon);
                }
            };

            $scope.validatePwz = function() {
                if($scope.wrapper.physicianDetails.pwz) {
                    userModel.pwzExistence($scope.wrapper.physicianDetails.pwz);
                }
            };

            $scope.trimBankAccount = function() {
                if($scope.wrapper.medicalPostAccounting.accountNumber) {
                    $scope.wrapper.medicalPostAccounting.accountNumber = $scope.wrapper.medicalPostAccounting.accountNumber.replace(/ /g, '');
                }
            };

            $scope.evaluatePwzRequirement = function() {
                var wrapper = $scope.wrapper;
                if (wrapper) {
                    var physicianDetails = wrapper.physicianDetails;
                    var firstSpecialization = physicianDetails.firstSpecialization;
                    var secondSpecialization = physicianDetails.secondSpecialization;
                    $scope.pwzRequired = (firstSpecialization && firstSpecialization.pwzRequired) ||
                                         (secondSpecialization && secondSpecialization.pwzRequired);
                }
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SETTINGS');
        }

        function initialize() {
            if($scope.isPhysician) {
                resourceModel.getDataPage($scope.criteria);
                userModel.getMyData();
                dictionaryModel.getStates();
                dictionaryModel.getSpecializations();
                dictionaryModel.getAcademicTitles();
                applicationModel.viewReady = true;
                medicalPostModel.getMedicalChamberList().then(function (medicalChamberList) {
                    $scope.medicalChamberList = medicalChamberList;
                });
            } else {
                $scope.goToAccessDenied();
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
